import { APIFailureAction, APIRequestAction, APISuccessAction } from 'mk2/helpers/action';
import { NormalizedResponse } from 'mk2/helpers/api';

///////////////////////////////////////////////////////////////////
// FAQ index load

export const FAQ_INDEX_FETCH_TRIGGER = 'FAQ_INDEX_FETCH_TRIGGER';
export interface FaqIndexFetchTriggerAction {
    readonly type: typeof FAQ_INDEX_FETCH_TRIGGER;
    readonly articleSlug: string;
    readonly query: string;
}
export const FAQ_INDEX_FETCH_REQUEST = 'FAQ_INDEX_FETCH_REQUEST';
export interface FaqIndexFetchRequestAction extends APIRequestAction {
    readonly type: typeof FAQ_INDEX_FETCH_REQUEST;
    readonly articleSlug: string;
    readonly query: string;
}
export interface FaqIndexFetchNormalizedResponse extends NormalizedResponse {
    readonly result: {
        article: number,
        articles: number[],
    };
}
export const FAQ_INDEX_FETCH_SUCCESS = 'FAQ_INDEX_FETCH_SUCCESS';
export interface FaqIndexFetchSuccessAction extends APISuccessAction<FaqIndexFetchNormalizedResponse> {
    readonly type: typeof FAQ_INDEX_FETCH_SUCCESS;
    readonly articleSlug: string;
    readonly query: string;
}
export const FAQ_INDEX_FETCH_FAILURE = 'FAQ_INDEX_FETCH_FAILURE';
export interface FaqIndexFetchFailureAction extends APIFailureAction {
    readonly type: typeof FAQ_INDEX_FETCH_FAILURE;
    readonly articleSlug: string;
    readonly query: string;
}

export const faqIndexFetchTrigger = (articleSlug: string, query): FaqIndexFetchTriggerAction => ({
    type: FAQ_INDEX_FETCH_TRIGGER, articleSlug, query,
});

export const faqIndexFetchApi = {
    request: (articleSlug, query: string): FaqIndexFetchRequestAction => ({
        type: FAQ_INDEX_FETCH_REQUEST, articleSlug, query,
    }),
    success: (articleSlug: string, query: string, response: FaqIndexFetchNormalizedResponse): FaqIndexFetchSuccessAction => ({
        type: FAQ_INDEX_FETCH_SUCCESS, articleSlug, query, response,
    }),
    failure: (articleSlug: string, query: string, error: any): FaqIndexFetchFailureAction => ({
        type: FAQ_INDEX_FETCH_FAILURE, articleSlug, query, error,
    }),
};
